import React from 'react'
import {Icon} from '@chakra-ui/react'

const RightIcon = (props) => {
    return (
        <Icon viewBox="0 0 40 40" {...props}>
            <path
                id="arrow"
                d="M22.9502 34.1001L20.9002 32.0001L29.1002 23.8001L31.6502 21.5001H2.9502V18.5001H31.6502L29.1002 16.1501L20.9002 8.00008L22.9502 5.90009L37.0502 20.0001L22.9502 34.1001Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export default RightIcon
